import { GET_CUSTIMIZED_TABLE_DATA, GET_CUSTIMIZED_TABLE_DATA_FOR_OVERVIEW, RESET_REDUX_STATE} from "../constants";

const initState = {
  customized_columns: "",
  customized_columns_overview: ""
};

const customizedTable = (state = initState, action) => {
  const { payload, type } = action;

  switch (type) {
    case GET_CUSTIMIZED_TABLE_DATA: {
      return {
        ...initState,
        customized_columns: payload,
      };
    }

    case GET_CUSTIMIZED_TABLE_DATA_FOR_OVERVIEW : {
      return {
        ...initState,
        customized_columns_overview: payload
      }
    }

    case RESET_REDUX_STATE: {
      return initState
    }

    default:
      return state;
  }
};

export default customizedTable